import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
const PackageSales = () => {
	//ApiData Component Content Variables
	const x = 0;
	const [positionID, setPositionID] = useState(get_cookies("position_id"));
	const [PackagesNavDetails, loadPackagesNav] = useState([]);
	const [contentNav, setContentNav] = useState("");
	const navigations = [];
	//OnLoad Event/Data Fetching
	useEffect(() => {
		get_package_navigation();
		getContentNavData();
	}, []);

	useEffect(() => {
		//
		isLoggedIn();
	}, [x]);

	//Api Functions SOF
	const get_package_navigation = () => {
		const formData = new FormData();
		const form_data = {
			positionID: positionID
		};
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL + "packagesnav";
		axios.post(apiUrl, formData, {
				headers:{
					"Content-Type": "multipart/form-data",
				}
			} ).then(res => {
			loadPackagesNav(res.data.packagesnav);
		});

		// axios.post(apiUrl, {form_data}).then(res => {
		// loadPackagesNav(res.data.packagesnav);
	// });

	};

	const getContentNavData = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "get_content_nav_data", {
				params: {
					name: "sales", //
					content_nav: get_cookies("content.nav.access")
				}
			})
			.then(function (res) {
				setContentNav(res.data.data);
			})
			.catch(function (error) {
				// console.log(error);
			});
	};
	//Api Request Functions EOF
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<h2 className="header-title">Package Sales</h2>
			</div>
			<div className="page-container">
				<Grid container spacing={2}>
					{contentNav ? (
						contentNav.map(item => {
							return item.cn_hasline == -2 ? (
								<Grid
									item
									xs={6}
									className="app-card-container"
									key={item.id}
									style={{
										"--cardBorderColor": item.nav_color
									}}
								>
									<NavLink to={item.cn_url} key={item.id}>
										<div className="app-card">
											{item.cn_name}
										</div>
									</NavLink>
								</Grid>
							) : null;
						})
					) : (
						<div></div>
					)}
					{PackagesNavDetails.map((value, index) => {
						// <option value={key}>{tifs[key]}</option>
						navigations.push(
							<Grid
								item
								xs={6}
								className="app-card-container"
								style={{
									"--cardBorderColor": value.nav_color
								}}
							>
								<NavLink
									to={
										"/package-sales-setpackage/" +
										value.id +
										"/" +
										value.nav_name
									}
								>
									<div className="app-card">
										{value.nav_name}
									</div>
								</NavLink>
							</Grid>
						);
					})}
					{navigations}
				</Grid>
			</div>
		</div>
	);
};

export default PackageSales;
